<template>
  <div id="app" style="width:100%;height:100%;background:rgba(240, 242, 243, 1)">
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  components: {

  },
  data () {
    return {
      locale: zhCN,
      pageTitle: '',
      faviconIcon: ''
    }
  },
  methods: {
    queryBasicInfo() {
      let host = window.location.host
      this.axios(
          {
          method:'get',
          url:'/api/login/loginInfo', 
          params: {
              hostName: host,
          }
      })
      .then(response=> {
          if(response.data.code == 0){
              this.basicInfo = response.data.data
              this.pageTitle = response.data.data.sysName
              this.faviconIcon = response.data.data.titleLogo
          }else{
              this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    }
  },
  mounted: function() {
    this.queryBasicInfo()
  },
  updated() {
    document.title = this.pageTitle;
    const favicon = document.getElementById('dynamic-favicon');
    favicon.href = this.faviconIcon
  }
}
</script>

<style>
  @import "./assets/css/global.scss";
  /* @import "./font-style/font.css";
  body{
    font-family: PingFang;
  } */
</style>
